(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5331],{

/***/ 37979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _lessonSlug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/api/routes/academy/queries/index.ts + 3 modules
var queries = __webpack_require__(79308);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Academy/components/Subnav/Subnav.tsx
var Subnav = __webpack_require__(58483);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Hero = function Hero(_ref) {
  var title = _ref.title,
      description = _ref.description,
      courseNumber = _ref.courseNumber,
      lessonNumber = _ref.lessonNumber;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHero, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopy, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Overline */.Lh, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Uppercase, {
              children: "Course"
            }), " ", courseNumber, " \u2022 Lesson ", lessonNumber]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h2",
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: description
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Hero_Hero = (Hero);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e6lgk1i3"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var Uppercase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e6lgk1i2"
} : 0)( true ? {
  name: "50zrmy",
  styles: "text-transform:uppercase"
} : 0);

var StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e6lgk1i1"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{text-align:center;}" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e6lgk1i0"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/components/Content/Content.tsx


function Content_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Content = function Content(_ref) {
  var data = _ref.data;
  var content = (0,react.useMemo)(function () {
    if (!data) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: data
    });
  }, [data]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArticle, {
          children: content
        })
      })
    })
  });
};

/* harmony default export */ var Content_Content = (Content);

var Content_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14fkxbt2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e14fkxbt1"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;}" + ( true ? "" : 0));

var StyledArticle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e14fkxbt0"
} : 0)( true ? {
  name: "15xdguq",
  styles: "max-width:844px;margin:auto;>*:first-child{margin-top:0;}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ./src/views/Academy/components/EmailFormSection/EmailFormSection.tsx
var EmailFormSection = __webpack_require__(33446);
// EXTERNAL MODULE: ./src/views/Academy/components/LessonCard/LessonCard.tsx
var LessonCard = __webpack_require__(27667);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/components/NextLesson/NextLesson.tsx


function NextLesson_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var copy = {
  heading: "Next lesson",
  completed: {
    heading: "Congratulations!",
    description: "You\u2019ve completed the last lesson in this course. If you\u2019re ready to keep learning you can start the next course below."
  }
};

var NextLesson = function NextLesson(_ref) {
  var _data$courseIcon, _data$courseIcon2;

  var data = _ref.data,
      courseNumber = _ref.courseNumber,
      courseIcon = _ref.courseIcon;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLesson_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: courseNumber === data.courseNumber ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Overline, {
              variant: "textBoldSmall",
              tokens: {
                color: theme.palette.twilio.gray[100]
              },
              children: [courseIcon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseIcon, {
                width: "24",
                height: "24",
                src: courseIcon === null || courseIcon === void 0 ? void 0 : courseIcon.src,
                alt: courseIcon === null || courseIcon === void 0 ? void 0 : courseIcon.title
              }), data.courseTitle]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "h3",
              variant: "h2",
              children: copy.heading
            })]
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCompleted, {
              status: "success",
              heading: copy.completed.heading,
              description: copy.completed.description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
              children: data.courseIcon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextCourseIcon, {
                width: "24",
                height: "24",
                src: (_data$courseIcon = data.courseIcon) === null || _data$courseIcon === void 0 ? void 0 : _data$courseIcon.src,
                alt: (_data$courseIcon2 = data.courseIcon) === null || _data$courseIcon2 === void 0 ? void 0 : _data$courseIcon2.title
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Heading */.X6, {
              tag: "h3",
              variant: "h2",
              children: ["Course: ", data.courseNumber, ": ", data.courseTitle]
            })]
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonCard/* default */.Z, {
          lesson: data
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailFormSection/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var NextLesson_NextLesson = (NextLesson);

var NextLesson_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rhtgxj5"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1rhtgxj4"
} : 0)("max-width:800px;", Section/* Wrapper */.im, "{gap:40px;}" + ( true ? "" : 0));

var CourseCompleted = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormSubmitAction/* default */.Z,  true ? {
  target: "e1rhtgxj3"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var Overline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e1rhtgxj2"
} : 0)( true ? {
  name: "1msd3bo",
  styles: "display:flex;gap:6px;align-items:center;justify-content:center"
} : 0);

var CourseIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1rhtgxj1"
} : 0)( true ? {
  name: "2kgb0i",
  styles: "width:24px;margin:0"
} : 0);

var NextCourseIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CourseIcon,  true ? {
  target: "e1rhtgxj0"
} : 0)( true ? {
  name: "1j43wle",
  styles: "width:36px;height:36px;margin:0 auto"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/components/WhatsNext/WhatsNext.tsx












var WhatsNext_copy = {
  heading: "What's next?",
  description: "Start connecting your data with Twilio Segment",
  completed: {
    heading: "Congratulations!",
    description: "You\u2019ve completed all lessons in the Twilio Segment Analytics Academy."
  }
};

var WhatsNext = function WhatsNext() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WhatsNext_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhatsNext_StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhatsNext_CourseCompleted, {
            status: "success",
            heading: WhatsNext_copy.completed.heading,
            description: WhatsNext_copy.completed.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            centered: true,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "h3",
              variant: "h2",
              children: WhatsNext_copy.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              tag: "p",
              children: WhatsNext_copy.description
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Buttons, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            size: "large",
            color: "primary",
            variant: "outlined",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
            children: "Get a demo"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
            tag: "a",
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: "Create a free account"
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

/* harmony default export */ var WhatsNext_WhatsNext = (WhatsNext);

var WhatsNext_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jw1tou3"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";overflow-y:auto;overflow-x:hidden;" + ( true ? "" : 0));

var WhatsNext_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1jw1tou2"
} : 0)("max-width:800px;", Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var WhatsNext_CourseCompleted = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormSubmitAction/* default */.Z,  true ? {
  target: "e1jw1tou1"
} : 0)("margin-bottom:50px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:120px;}" + ( true ? "" : 0));

var Buttons = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jw1tou0"
} : 0)("margin-top:40px;display:grid;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{margin-left:40px;margin-right:40px;grid-template-columns:1fr 1fr;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/components/FaqSection/FaqSection.tsx







var FaqSection_copy = {
  heading: "Frequently asked questions"
};

var FaqSection = function FaqSection(_ref) {
  var data = _ref.data;
  var items = new Array(data.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: FaqSection_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* JsonLdFaq */.yD, {
        data: data.map(function (_ref2) {
          var answer = _ref2.answer,
              question = _ref2.question;
          return {
            question: question,
            answer: answer
          };
        })
      }), activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                opened: active,
                children: data[index].question
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: data[index].answer
              })
            })
          })]
        }, "item-".concat(index));
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eye64k51"
} : 0)("padding-bottom:28px;text-align:center;margin-top:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:44px;}" + ( true ? "" : 0));

var FaqSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eye64k50"
} : 0)("max-width:1004px;overflow-x:unset;", Section/* Wrapper */.im, "{padding-top:0;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("xs");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var FaqSection_FaqSection = (FaqSection);
;// CONCATENATED MODULE: ./src/views/Academy/SinglePage/AcademyLesson.tsx















var AcademyLessonView = function AcademyLessonView(_ref) {
  var _data$image;

  var courseSlug = _ref.courseSlug,
      lessonSlug = _ref.lessonSlug;

  var _useLessonQuery = (0,queries/* useLessonQuery */.Ct)({
    args: [{
      courseSlug: courseSlug,
      lessonSlug: lessonSlug
    }]
  }),
      data = _useLessonQuery.data;

  var _useCoursesQuery = (0,queries/* useCoursesQuery */.x5)({
    args: []
  }),
      _courses = _useCoursesQuery.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: data.courseTitle,
      pageDescription: data.description,
      pageOG: (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.src,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {
        after: _courses && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
          data: _courses === null || _courses === void 0 ? void 0 : _courses.map(function (course) {
            return {
              title: course.title,
              courseNumber: course.courseNumber,
              slug: course.slug,
              lessons: course.lessons.map(function (lesson) {
                return {
                  title: lesson.title,
                  slug: lesson.slug
                };
              })
            };
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        title: data.title,
        description: data.description,
        courseNumber: data.courseNumber,
        lessonNumber: data.lessonNumber
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content_Content, {
          data: data.content
        }), data.faqs && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_FaqSection, {
          data: data.faqs
        }), data.nextLesson ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLesson_NextLesson, {
          data: data.nextLesson,
          courseNumber: data.courseNumber,
          courseIcon: data.courseIcon
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhatsNext_WhatsNext, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ehwvxze0"
} : 0)( true ? "" : 0);

/* harmony default export */ var AcademyLesson = (AcademyLessonView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/academy/[courseSlug]/[lessonSlug].tsx





var AcademyLessonPage = function AcademyLessonPage(_ref) {
  var courseSlug = _ref.courseSlug,
      lessonSlug = _ref.lessonSlug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AcademyLesson, {
      courseSlug: courseSlug,
      lessonSlug: lessonSlug
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _lessonSlug_ = (AcademyLessonPage);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 19587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/[courseSlug]/[lessonSlug]",
      function () {
        return __webpack_require__(37979);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,442,4881,9833,2588,9774,2888,179], function() { return __webpack_exec__(19587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);